import {Base} from '../../common/model/base.model';
import {TableRow} from '../../common/model/table-row.model';
import {TableRowValue} from '../../common/model/table-row-value.model';
import {CategoriaGerarchia} from './categoria-gerarchia.enum';

export class TipoGerarchia extends Base {

  constructor(protected id: number,
              public descr: string,
              public sigla: string,
              public categoria: CategoriaGerarchia,
              public utilizzo: number) {
    super(id);
  }

  public static getTableKeys() {
    return ['id', 'descr', 'sigla', 'categoria', 'utilizzo'];
  }

  public getLabel() {
    return this.descr;
  }

  public toTableRow(): TableRow {
    const rowValues = new Map();
    rowValues.set('id', new TableRowValue(this.id, null));
    rowValues.set('descr', new TableRowValue(this.descr, null));
    rowValues.set('sigla', new TableRowValue(this.sigla, null));
    rowValues.set('categoria', new TableRowValue(this.categoria.getEnumValue(), null));
    rowValues.set('utilizzo', new TableRowValue(this.utilizzo, null));
    return new TableRow(this, rowValues);
  }
}
